import styled from '@emotion/styled';

export const StepTitle = styled.h1`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.56px;
`;

export const ErrorTitle = styled.h1`
    display: flex;
    align-items: center;
    gap: 16px;

    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.56px;
    margin-block-end: 8px;
`;
